import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import ProfileWrapper from '../../components/Customer/ProfileWrapperView';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import DetailView from '../../components/Customer/Profile/DetailView';
import RemoveView from '../../components/Customer/Profile/RemoveView';
import PasswordView from '../../components/Customer/Profile/PasswordView';
import OrderLayout from './Order';
import 'react-tabs/style/react-tabs.scss';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';
import {bindActionCreators} from 'redux';
import * as userActions from '../../actions/userActions';
import {actionWrapper} from '../../helpers/index';

class ProfileLayout extends Component {
  constructor(props) {
    super(props);

    this.selectTab = this.selectTab.bind(this);
    this.close = this.close.bind(this);
    this.editProfile = this.editProfile.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.updateUser = this.updateUser.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
    this.removeUser = this.removeUser.bind(this);
    this.closeFlash = this.closeFlash.bind(this);
    this.clearError = this.clearError.bind(this);
    this.state = {
      title: 'information_personal',
      editableProfile: null,
      errors: {},
      inProgress: false,
      flash: {},
    };
  }

  componentDidMount() {
    this.props.getProfileUser();
  }

  close() {
    this.props.history.goBack();
  }

  selectTab(title) {
    this.setState({
      title: title,
      flash: {},
    });
    this.cancelEdit();
    this.closeFlash();
  }

  editProfile() {
    this.setState({
      editableProfile: this.props.user.toObject(),
      inProgress: false,
    });
    this.closeFlash();
  };

  cancelEdit() {
    this.setState({
      editableProfile: null,
      inProgress: false,
      errors: {},
    });
  }

  updateUser(data) {
    return actionWrapper(this, data, this.props.updateUser).then(() => {
      this.cancelEdit();
      this.setFlash('success', 'update_profile_success');
    });
  }

  updatePassword(data) {
    actionWrapper(this, data, this.props.updateUser).then(() => {
      this.setFlash('success', 'update_password_success');
    });
  }

  removeUser(data) {
    actionWrapper(this, data, this.props.removeUser).then(() => {
      this.props.history.push(`/${this.props.language}/${this.props.restaurant.name_for_url}/products/pizza`);
    });
  }

  closeFlash() {
    this.setState({
      flash: {},
    });
  }

  setFlash(type, message) {
    this.setState({
      flash: {
        type: type,
        message: message,
      },
    });
  }

  clearError() {
    this.setState({
      errors: {},
    });
  }

  render() {
    const {user, t} = this.props;
    const {title, errors, editableProfile, inProgress, flash} = this.state;
    return (
      <ProfileWrapper
        title={t(title)}
        onClose={this.close}
        toast={flash}>
        <Tabs>
          <TabList>
            <Tab onClick={() => this.selectTab('information_personal')}>
              <div className="profile__icon profile__icon--personal">
              </div>
              {t('information_personal')}
            </Tab>
            <Tab onClick={() => this.selectTab('change_password')}>
              <div className="profile__icon profile__icon--password">
              </div>
              {t('change_password')}
            </Tab>
            <Tab onClick={() => this.selectTab('orders')}>
              <div className="profile__icon profile__icon--history">
              </div>
              {t('orders')}
            </Tab>
            <Tab onClick={() => this.selectTab('delete_account')}>
              <div className="profile__icon profile__icon--delete">
              </div>
              {t('delete_account')}
            </Tab>
          </TabList>
          <TabPanel>
            <DetailView
              profile={!!editableProfile ? editableProfile : user.toObject()}
              action={this.updateUser}
              errors={errors}
              onEdit={this.editProfile}
              onCancel={this.cancelEdit}
              inProgress={inProgress}
            />
          </TabPanel>
          <TabPanel>
            <PasswordView
              profile={user.toObject()}
              action={this.updatePassword}
              errors={errors}
              inProgress={inProgress}
              current={!user.isEmpty()}
              closeFlash={this.closeFlash}
              clearError={this.clearError}
              flash={flash}
            />
          </TabPanel>
          <TabPanel>
            <OrderLayout/>
          </TabPanel>
          <TabPanel>
            <RemoveView
              profile={user.toObject()}
              removeAction={this.removeUser}
              inProgress={inProgress}
            />
          </TabPanel>
        </Tabs>
      </ProfileWrapper>
    );
  }
}

ProfileLayout.propTypes = {
  user: PropTypes.object,
  updateUser: PropTypes.func.isRequired,
  removeUser: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: state.user.get('profile'),
    restaurant: state.restaurants.item,
    language: state.language.defaultLanguage
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateUser: bindActionCreators(userActions.updateUser, dispatch),
    removeUser: bindActionCreators(userActions.removeUser, dispatch),
    getProfileUser: bindActionCreators(userActions.getProfileUser, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  translate('translations')(ProfileLayout)));


// WEBPACK FOOTER //
// ./src/containers/Customer/Profile.js